




























































































































































































































































































































































































































































































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import RoundModule from '@/store/modules/Round';
import ReportModule from '@/store/modules/Report';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ManageMixin from '@/mixins/Manage.vue';
import Pagination from '@/components/Pagination.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import Table from '@/components/Table/Index.vue';
import RoundBody from '@/components/Table/RoundBody.vue';
import RoundTracking from '@/components/Table/RoundTracking.vue';
import RoundCancel from '@/components/Table/RoundCancel.vue';
import RoundModalTracking from '@/components/RoundModalTracking.vue';
import RoundModalDetail from '@/components/RoundModalDetail.vue';
import RoundModalTrackingBet from '@/components/RoundModalTrackingBet.vue';
import RoundModalRound from '@/components/RoundModalRound.vue';
import RoundModalAxios from '@/components/RoundModalAxios.vue';
import RoundData from '@/data/RoundData';
import RoundModalCancelDetail from '@/components/RoundModalCancelDetail.vue';
import utils from '@/services/utils';
import cryptoJs from 'crypto-js';

@Component({
  components: {
    Table,
    Pagination,
    RoundBody,
    RoundTracking,
    RoundCancel,
    RoundModalTracking,
    RoundModalDetail,
    RoundModalTrackingBet,
    RoundModalRound,
    RoundModalAxios,
    RoundModalCancelDetail,
  },
})

export default class RoundView extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
  ManageMixin,
) {
  AuthInstance = getModule(AuthModule, this.$store);

  RoundInstance = getModule(RoundModule, this.$store);

  ReportInstance = getModule(ReportModule, this.$store);

  FilltersTableHead: any = [...RoundData.TableHead];

  FilltersHeadDetail: any = [...RoundData.TableHead];

  TableHeadLog: any = [];

  loginName = '';

  roundName = '';

  filterRound = '';

  isMember = false;

  roundData: any = [];

  roundType = 'round';

  modalRoundCancel = false;

  modalRoundDetail = false;

  modalTracking = false;

  modalTrackingBet = false;

  modalCancelDetail = false;

  modalAxios = false;

  modalRound = false;

  modalDetail = false;

  modalRoundUpdate = false;

  select = false;

  isCheck = false;

  selectAll = false;

  roundSelect: any = []

  modalType = '';

  username = ''

  modalState: any = []

  trackingList: any = [];

  axiosList: any = [];

  roundTrackingList: any = []

  dataRoundPrepare: any = []

  selected: any = {};

  dataSelectAll: any = [];

  componentKey = 0;

  Criteria = {
    isSearch: false,
    username: '',
    roundName: '',
  };

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  count = 0;

  startDate = '';

  endDate = '';

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  async created() {
    this.fetchRound();
    this.roundChange();
  }

  beforeFetch(item) {
    this.Criteria.roundName = item._id;
    this.PaginationDetail.current = 1;
    this.fetchRound();
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      isSearch: false,
      username: this.loginName,
      roundName: this.roundName,
    };
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.calPagination({ ...this.paginationParams });
    if (this.isMember) this.fetchRound();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchRoundCancel();
  }

  onSubmitRound() {
    this.fetchRound();
  }

  async fetchRound() {
    this.GeneralInstance.toggleLoading(true);
    this.Criteria.isSearch = !!this.roundName;
    const criteria: any = {
      ...this.Criteria,
      ...this.Period,
    };
    const res = await this.RoundInstance.FetchRoundTable(criteria);
    this.roundData = this.RoundInstance.roundData;
    this.dataRoundPrepare = [];
    this.RoundInstance.mutateRoundSelect(this.dataRoundPrepare);
    this.RoundInstance.mutateRoundSelectAll(this.dataRoundPrepare);
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  onSubmit() {
    this.fetchRoundCancel();
  }

  async fetchRoundCancel() {
    this.GeneralInstance.toggleLoading(true);
    this.Criteria.isSearch = !!this.loginName;
    const criteria: any = {
      ...this.Criteria,
      ...this.Period,
    };
    const res = await this.RoundInstance.FetchRoundLog(criteria);
    this.roundData = await this.RoundInstance.roundData;
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  async fetchResult(params) {
    const {
      roundId, username, source, axiosData,
    } = params;
    const strWindowFeatures = 'top=0,left=0,height=750,width=750,scrollbars=yes';
    const param = {
      roundId,
      username,
      currency: {
        abb: axiosData.bet.request[0].currency,
      },
      language: this.$i18n.locale,
      source,
      prefix: axiosData.bet.request[0].gameId,
    };
    const res = await this.ReportInstance.FetchTransaction(param);
    const encrypt = cryptoJs.AES.encrypt(JSON.stringify(param), '4141DF79AEA07A075549AA6AEB1D7824');
    const url = res.url.charAt(res.url.length - 1) !== '/' ? `${res.url}/` : res.url;
    const link = `${url}?t=${utils.getUserPersistent().token}&p=${encrypt.toString()}`;
    window.open(link, 'gameResult', strWindowFeatures);
  }

  async roundChange() {
    if (this.roundType === 'round') {
      this.roundName = '';
      this.FilltersTableHead = [RoundData.TableHead[0]];
      this.fetchRound();
    }
    if (this.roundType === 'tracking') {
      this.loginName = '';
      this.trackingList = [];
      this.FilltersTableHead = [RoundData.TableHead[1]];
    }
    if (this.roundType === 'cancel') {
      this.loginName = '';
      this.FilltersTableHead = [RoundData.TableHead[2]];
      this.fetchRoundCancel();
    }
  }

  toggleModalCancel() {
    this.modalRoundCancel = !this.modalRoundCancel;
  }

  toggleModalUpdate() {
    this.modalRoundUpdate = !this.modalRoundUpdate;
  }

  handleSearch() {
    this.Criteria.username = this.loginName;
    this.Criteria.roundName = this.roundName;
  }

  handleSearchTracking() {
    this.openModalTracking(this.loginName, 'search');
  }

  handleModalDetail(items) {
    this.FilltersHeadDetail = [RoundData.TableHead[5]];
    this.roundSelect = items;
    this.modalRoundDetail = true;
  }

  handleModalRoundDetail(item) {
    this.TableHeadLog = [RoundData.TableHead[3]];
    this.roundSelect = item;
    this.modalDetail = true;
  }

  async updateRound() {
    this.GeneralInstance.toggleLoading(true);
    this.dataRoundPrepare.map(async (v) => {
      const data = {
        roundList: [
          v,
        ],
      };
      const res = await this.RoundInstance.RoundUpdate(data);
      this.checkError(res.status);
      this.modalRoundUpdate = false;
      this.GeneralInstance.toggleLoading(false);
      this.fetchRound();
    });
  }

  async cancelRound() {
    this.GeneralInstance.toggleLoading(true);
    this.dataRoundPrepare.map(async (v) => {
      const data = {
        roundList: [
          v,
        ],
      };
      const res = await this.RoundInstance.RounceCancelList(data);
      this.checkError(res.status);
      this.modalRoundCancel = false;
      this.GeneralInstance.toggleLoading(false);
      if (this.roundType === 'round') {
        this.fetchRound();
      }
      if (this.roundType === 'cancel') {
        this.fetchRoundCancel();
      }
    });
  }

  async cancelOneRound() {
    this.GeneralInstance.toggleLoading(true);
    const data = {
      roundList: this.roundSelect._id,
    };
    const res = await this.RoundInstance.RounceCancel(data);
    this.checkError(res);
    this.GeneralInstance.toggleLoading(false);
    this.modalDetail = false;
    if (this.roundType === 'round') {
      this.fetchRound();
    }
    if (this.roundType === 'cancel') {
      this.fetchRoundCancel();
    }
  }

  selectRound(data, item) {
    if (data) {
      this.dataRoundPrepare.push(item._id);
    } else {
      this.dataRoundPrepare = this.dataRoundPrepare.filter((v) => v !== item._id);
    }
    if (this.roundData.pendingList.length === this.dataRoundPrepare.length) {
      this.RoundInstance.mutateRoundSelectAll(true);
    } else {
      this.RoundInstance.mutateRoundSelectAll(false);
    }
  }

  async selectCheckAll(selectAll) {
    if (selectAll) {
      this.roundData.pendingList.forEach((v: any, index) => {
        this.selected[v._id] = selectAll;
        this.dataSelectAll = this.roundData.pendingList[index]._id;
        this.dataRoundPrepare.push(this.dataSelectAll);
      });
    } else {
      this.roundData.pendingList.forEach((v: any) => {
        this.selected[v._id] = selectAll;
      });
      this.dataRoundPrepare = [];
    }
    this.componentKey += 1;
    this.RoundInstance.mutateRoundSelect(this.selected);
    this.RoundInstance.mutateRoundSelectAll(selectAll);
  }

  async openModalTracking(items, typeModal) {
    this.GeneralInstance.toggleLoading(true);
    this.modalType = typeModal;
    if (this.modalType) {
      this.modalState = this.modalType.split('_');
      this.modalState = this.modalState[0].toLowerCase();
    }
    const item = items._id ? items._id : items;
    const data = {
      roundId: item,
    };
    const res = await this.RoundInstance.FetchReportRoundLog(data);
    if (res.code !== 0 || res.tracking.length === 0) {
      this.checkError(res);
      this.GeneralInstance.toggleLoading(false);
    }
    this.trackingList = res.tracking.map((v) => ({
      username: v.username || '',
      roundId: v.roundId || '',
      source: v.source || '',
      type: {
        bet: v.type === 'BET' ? v.type : '',
        payout: v.type === 'PAYOUT' ? v.type : '',
        cancel: v.type === 'CANCEL' ? v.type : '',
      },
      createDateTracking: {
        bet: v.type === 'BET' ? v.createDate : '',
        payout: v.type === 'PAYOUT' ? v.createDate : '',
        cancel: v.type === 'CANCEL' ? v.createDate : '',
      },
      trackingType: {
        bet: v.type === 'BET' ? v.type : '',
        payout: v.type === 'PAYOUT' ? v.type : '',
        cancel: v.type === 'CANCEL' ? v.type : '',
      },
      trackingData: {
        bet: v.type === 'BET' ? [v] : [],
        payout: v.type === 'PAYOUT' ? [v] : [],
        cancel: v.type === 'CANCEL' ? [v] : [],
      },
      // Axios Section
      createDateAxios: {},
      updateDateAxios: {},
      path: {},
      axiosType: {},
      axiosData: {
        bet: {
          request: [],
          response: [],
        },
        payout: {
          request: [],
          response: [],
        },
        cancel: {
          request: [],
          response: [],
        },
      },
      uuid: {},
      httpStatus: {},
      // Round Section
      roundType: {},
      roundData: {
        bet: [],
        payout: [],
        cancel: [],
      },
    }));

    this.axiosList = res.axios.map((v) => ({
      username: v.username || '',
      createDateAxios: {
        bet: v.path === 'bet' ? v.createDate : '',
        payout: v.path === 'payout' ? v.createDate : '',
        cancel: v.path === 'cancel' ? v.createDate : '',
      },
      updateDateAxios: {
        bet: v.path === 'bet' ? v.updateDate : '',
        payout: v.path === 'payout' ? v.updateDate : '',
        cancel: v.path === 'cancel' ? v.updateDate : '',
      },
      path: {
        bet: v.path === 'bet' ? v.path : '',
        payout: v.path === 'payout' ? v.path : '',
        cancel: v.path === 'cancel' ? v.path : '',
      },
      axiosType: {
        bet: v.path === 'bet' ? v.path : '',
        payout: v.path === 'payout' ? v.path : '',
        cancel: v.path === 'cancel' ? v.path : '',
      },
      axiosData: {
        bet: {
          request: v.path === 'bet' ? v.request : [],
          response: v.path === 'bet' ? v.response : [],
        },
        payout: {
          request: v.path === 'payout' ? v.request : [],
          response: v.path === 'payout' ? v.response : [],
        },
        cancel: {
          request: v.path === 'cancel' ? v.request : [],
          response: v.path === 'cancel' ? v.response : [],
        },
      },
      uuid: {
        bet: v.path === 'bet' ? v.uuid : '',
        payout: v.path === 'payout' ? v.uuid : '',
        cancel: v.path === 'cancel' ? v.uuid : '',
      },
      httpStatus: {
        bet: v.path === 'bet' ? v.httpStatus : '',
        payout: v.path === 'payout' ? v.httpStatus : '',
        cancel: v.path === 'cancel' ? v.httpStatus : '',
      },
    }));

    const trackingModel: any = {};
    this.trackingList.forEach((v: any) => {
      const type = Object.values(v.type).filter((w: any) => w.length)[0] as string;
      const types = type.toLowerCase();
      if (!trackingModel[v.username]) {
        trackingModel[v.username] = v;
      } else {
        trackingModel[v.username].createDateTracking[`${types}`] = v.createDateTracking[`${types}`];
        trackingModel[v.username].roundId = v.roundId;
        trackingModel[v.username].source = v.source;
        trackingModel[v.username].type[`${types}`] = types.toUpperCase();
        trackingModel[v.username].trackingType[`${types}`] = v.trackingType[`${types}`];
        trackingModel[v.username].trackingData[`${types}`].push(...v.trackingData[`${types}`]);
      }
    });

    this.axiosList.forEach((v: any) => {
      const path = Object.values(v.path).filter((w: any) => w.length)[0] as string;
      if (!trackingModel[v.username]) {
        trackingModel[v.username] = v;
      } else {
        trackingModel[v.username].createDateAxios[`${path}`] = v.createDateAxios[`${path}`];
        if (v.httpStatus[`${path}`] === '200') {
          trackingModel[v.username].httpStatus[`${path}`] = trackingModel[v.username].httpStatus[`${path}`] || v.httpStatus[`${path}`];
        }
        trackingModel[v.username].axiosType[`${path}`] = path.toUpperCase();
        trackingModel[v.username].updateDateAxios[`${path}`] = v.updateDateAxios[`${path}`];
        trackingModel[v.username].uuid[`${path}`] = v.uuid[`${path}`];
        trackingModel[v.username].axiosData[`${path}`].request.push(...v.axiosData[`${path}`].request);
        trackingModel[v.username].axiosData[`${path}`].response.push(...v.axiosData[`${path}`].response);
      }

      res.axios.forEach((w, j) => {
        if (
          w.request.length
                  && w.response.length
                  && w.path === path
                  && w.response[0].status
                  && w.response[0].status.code === 0
                  && w.httpStatus === '200'
        ) {
          if (w.request[0].username === trackingModel[this.axiosList[j].username].username) {
            trackingModel[this.axiosList[j].username][`${path}Status`] = 'SUCCESS';
          }
        }
      });
    });

    if (res.round.length) {
      res.round[0].bet.forEach((v, i) => {
        if (Object.prototype.hasOwnProperty.call(trackingModel, v.username)) {
          trackingModel[v.username].roundType.bet = 'BET';
          trackingModel[v.username].roundData.bet.push({
            index: 1 + i,
            ...v,
          });
        }
      });

      res.round[0].payout.forEach((v, i) => {
        if (Object.prototype.hasOwnProperty.call(trackingModel, v.username)) {
          trackingModel[v.username].roundType.payout = 'PAYOUT';
          trackingModel[v.username].roundData.payout.push({
            index: 1 + i,
            ...v,
          });
        }
      });
    }

    const finalArray: any = [];
    Object.keys(trackingModel).forEach((v) => {
      if (Object.prototype.hasOwnProperty.call(trackingModel, v)) {
        finalArray.push(trackingModel[v]);
      }
    });
    this.roundTrackingList = finalArray.map((v, i) => ({
      index: 1 + i,
      ...v,
      status: this.checkStatusRoundTracking(v),
    }));
    this.trackingList = this.roundTrackingList;
    if (typeModal === 'search') {
      this.modalCancelDetail = false;
      this.FilltersTableHead = [RoundData.TableHead[4]];
      this.trackingList = this.roundTrackingList;
    }
    if (['Bet_Tracking', 'Payout_Tracking', 'Cancel_Tracking'].includes(typeModal)) {
      this.TableHeadLog = [RoundData.TableHead[6]];
      this.modalTrackingBet = true;
    }
    if (['Bet_Round', 'Payout_Round', 'Cancel_Round'].includes(typeModal)) {
      this.TableHeadLog = [RoundData.TableHead[7]];
      this.modalRound = true;
    }
    if (['Bet_Axios', 'Payout_Axios', 'Cancel_Axios'].includes(typeModal)) {
      this.TableHeadLog = [RoundData.TableHead[8]];
      this.modalAxios = true;
    }
    if (!typeModal) {
      this.modalCancelDetail = true;
      this.FilltersHeadDetail = [RoundData.TableHead[4]];
    }
    this.checkStatusRound(items, typeModal);
    this.GeneralInstance.toggleLoading(false);
  }

  checkStatusRoundTracking(item) {
    if (item.cancelStatus === 'SUCCESS') return 'CANCEL SUCCESS';
    if (item.betStatus === 'SUCCESS' && item.payoutStatus === 'SUCCESS') return 'PAYOUT SUCCESS';
    return 'FAILED';
  }

  checkStatusRound(item, type) {
    if (!item.axiosData.bet.request.length) {
      if (['BET'].includes(item.trackingType.bet && item.roundType.bet) && ['PAYOUT'].includes(item.trackingType.payout && item.roundType.payout)) return type === 'message' ? 'PAYOUT SUCCESS' : 'text-currency-positive';
      if (['CANCEL'].includes(item.trackingType.cancel && item.roundType.cancel && item.axiosType.cancel)) return type === 'message' ? 'CANCEL SUCCESS' : 'text-currency-positive';
      return type === 'message' ? 'FAILED' : 'text-currency-negative';
    }
    if (
      ['BET'].includes(item.trackingType.bet && item.roundType.bet && item.axiosType.bet)
        && ['PAYOUT'].includes(item.trackingType.payout && item.roundType.payout && item.axiosType.payout)
        && ['200'].includes(item.httpStatus.bet && item.httpStatus.payout)
        && item.axiosData.payout.response.length === 1
    ) return type === 'message' ? 'PAYOUT SUCCESS' : 'text-currency-positive';
    if (
      ['CANCEL'].includes(item.trackingType.cancel
          || item.roundType.cancel
          || item.axiosType.cancel)
        && item.httpStatus.cancel === '200'
        && typeof item.axiosData.cancel.response[0] === 'object'
        && !item.axiosData.cancel.response[item.axiosData.cancel.response.length - 1].status.code
    ) {
      return type === 'message' ? 'CANCEL SUCCESS' : 'text-currency-positive';
    }
    return type === 'message' ? 'FAILED' : 'text-currency-negative';
  }
}
